import cn from 'bem-cn';

import { formatDateToShortRussian } from '../../../utils/date/date';
import { Cut, List, Stack, Tag, Video } from '../../UI';

import { ChallengeInfoHeaderProps } from './ChallengeInfoHeader.types';
import './ChallengeInfoHeader.scss';

const b = cn('challenge-info-header');

const renderTag = (item: string) => <Tag text={item} />;
const extractTagKey = (item: string) => `tag-${item}`;

export const ChallengeInfoHeader = (props: ChallengeInfoHeaderProps) => {
    const { title, description, deadline, videoData } = props.challenge;
    const { url: videoUrl, poster: videoPoster } = videoData;

    const formattedDeadline = formatDateToShortRussian(deadline);
    const tags = ['Челлендж', `До ${formattedDeadline}`];

    return (
        <Stack className={b()}>
            <Stack className={b('text-container')}>
                <List
                    direction="row"
                    justifyContent="center"
                    className={b('tags')}
                    items={tags}
                    renderItem={renderTag}
                    keyExtractor={extractTagKey}
                />
                <Stack spacing={8}>
                    <h1>{title}</h1>
                    <Cut maxLines={5}>{description}</Cut>
                </Stack>
            </Stack>
            <Video
                className={b('video')}
                src={videoUrl}
                poster={videoPoster}
                autoPlay
                muted
                loop
                playsInline
                disablePictureInPicture
            />
        </Stack>
    );
};
